<template>
    <div>
      <line-chart :options="options" :chartData="graphmodel"></line-chart>
    </div>
</template>

<script>
    import LineChart from "../charts/line-chart"
    import {PageControl} from "@/store/models/layout/page_control"
    import {VserverGraph} from "@/store/models/vserver/vserver_graph";
    import formatPriceMixin from "../../mixins/formatPriceMixin";


    export default {
        name: "luma-vserver-main-chart",
        components: {LineChart},
        mixins: [formatPriceMixin],
        props:{
            catkey:String,
            category:String,
            sec_catkey:String,
            sec_category:String
        },
        data:()=>({
            time:'',
            cf:'AVERAGE',
            liveLabel:[],
            showCapacity: true
        }),

        computed:{
            options(){
                return {
                    title: {
                        display: true,
                        text: this.catkey,
                        position:'top'
                    },
                    responsive: true,
                    maintainAspectRatio:false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: false,
                                reverse:true
                            }
                        }]
                    },
                    scales: this.yAchesMixin(),
                    tooltips:this.tooltip_creator(),
                    legend: {
                        display: false,
                        position:'top'
                    },
                    layout:{
                        padding:{
                            top:0,
                            bottom:0,
                            left: 10,
                            right: 10,
                        }
                    }
                }
            },
            vid(){
                !this.pageControll ? 0 : 1
                return this.$route.params.id || undefined
            },
            routeName(){
                return this.$route.name
            },
            modelKeyC(){
                return this.vid+'_'+this.time+'_'+this.cf
            },
            modelC(){
                return VserverGraph.find(this.modelKeyC) || undefined
            },
            pageControll(){
                if(PageControl.find(this.$route.name).changes ){
                    this.time = PageControl.find(this.$route.name).selected.time
                    this.cf = PageControl.find(this.$route.name).selected.cf
                    this.showCapacity = PageControl.find(this.$route.name).selected.capacity
                }
                return PageControl.find(this.$route.name) || undefined
            },
            labels() {
                // if(this.time === 'live') return this.modelC['time'].map((el,index)=>this.$moment.unix(el).format('hh:mm:ss'))
                if(this.time === 'live') return this.modelC['time'].map((el,index)=>this.$moment.unix(el).format('hh:mm:ss'))
                if(this.time === 'hour') return this.modelC['time'].map((el,index)=>this.$moment.unix(el).format('hh:mm'))
                if(this.time === 'year'){
                    // return this.modelC['time'].map((el,index)=>Date(el/1000))
                    return this.modelC['time'].map((el,index)=>this.$moment.unix(el).format('DD.MM.YY, hh:mm'))
                }
                return this.modelC['time'].map((el,index)=>this.$moment.unix(el).format('DD.MM.YY, hh:mm'))
                return this.modelC['time'].map((el,index)=>el)
            },
            graphmodel(){
            if(!VserverGraph.find(this.modelKeyC)) return
            const x = Object.assign({},VserverGraph.find(this.modelKeyC))
            const n = this.$nextTick()
            const y =  {
                labels:this.labels,
                datasets : [
                    {
                        data: x[this.category].map(el=>
                            el
                        ),
                        backgroundColor: ['rgba(115, 162, 192, 0.9)'],
                        label:[this.catkey,this.cf]
                    },
                ]
            }
            if (this.sec_category && this.sec_catkey){
                y.datasets.push({
                    data:x[this.sec_category],
                    label:[this.sec_catkey,this.cf]
                })
              }
            if(this.showCapacity && this.category !== 'cpu') y.datasets.push({
                data:x['max'+this.category],
                //type:'line',
                //fill: false,
                borderColor: 'rgba(135, 192, 192, 1)',
                label:'Maximal',
                backgroundColor:['rgba(135, 192, 192, 0.3)']
            })
            //if(this.category==='mem' && this.showCapacity) y.datasets.push({data:x['maxmem']})
            //if(this.category==='cpu' && this.showCapacity) y.datasets.push({data:x['maxcpu']})
            //if(this.catKey==='cpu') y.datasets.push({data:x['maxcpu']})
            return y || undefined
            },
        },
        methods:{
            tooltip_creator(){
                switch (this.category){
                    case 'cpu':  return{
                        callbacks:{
                            label: function (tooltipItem,data) {
                                return Math.round((tooltipItem.yLabel + Number.EPSILON) * 100)  + '%'
                            }
                        }
                    }
                    default   :  return {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                // let d = Math.round((tooltipItem.yLabel + Number.EPSILON) * 100) / 100
                                // let label = Math.round(tooltipItem.yLabel * 100) / 100;
                                // console.log('TOOLTIP:::',typeof tooltipItem.yLabel,data)
                                // return label;
                                const max_floor_length = Math.floor(tooltipItem.yLabel).toString().length
                                if (max_floor_length < 5) {
                                    const x = Math.round(tooltipItem.yLabel  / 1024 * 100 + Number.EPSILON ) / 100
                                    return x + ' KB'
                                }
                                else if (max_floor_length < 7) {
                                    const x = Math.round( tooltipItem.yLabel / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                    return x + ' MB'
                                }
                                else {
                                    const x = Math.round( tooltipItem.yLabel / 1024 / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                    return x + ' GB'
                                }
                            }
                        }
                    }
                }

            },
            getG(){
                //if(this.time === 'live') {this.timer = setInterval(this.getG(), 4000)}
                //if(this.time !== 'live') {clearInterval(this.timer)}
                // if(this.time === 'live') {
                //     const t = Date.now()
                //     this.liveLabel.push(this.$moment(t).format('hh:mm:ss'))
                // }
                VserverGraph.getGraph(this.vid, this.cf, this.time)
            },
            yAchesMixin(){
                switch (this.category){
                    case 'cpu': return {
                        yAxes: [{
                            ticks: {
                                callback: function(value,index,values){
                                    return Math.round((value + Number.EPSILON) * 100)  + '%'
                                }
                            }
                        }]
                    }
                    case 'mem': return {
                        yAxes: [{
                            ticks: {
                                callback: function(value,index,values){
                                    const max = Math.max(...values)
                                    const max_floor_length = Math.floor(max).toString().length
                                    if (max_floor_length < 5) {
                                        const x = Math.round( value / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' KB'
                                    }
                                    else if (max_floor_length < 7) {
                                        const x = Math.round( value / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' MB'
                                    }
                                    else {
                                        const x = Math.round( value / 1024 / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' GB'
                                    }
                                }
                            }
                        }]
                    }
                    case 'diskwrite': return {
                        yAxes: [{
                            ticks: {
                                callback: function(value,index,values){
                                    const max = Math.max(...values)
                                    const max_floor_length = Math.floor(max).toString().length

                                    if (max_floor_length < 5) {
                                        const x = Math.round( value / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' KB'
                                    }
                                    else if (max_floor_length < 7) {
                                        const x = Math.round( value / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' MB'
                                    }
                                    else {
                                        const x = Math.round( value / 1024 / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' GB'
                                    }
                                }
                            }
                        }]
                    }
                    case 'netin': return {
                        yAxes: [{
                            ticks: {
                                callback: function(value,index,values){
                                    const max = Math.max(...values)
                                    const max_floor_length = Math.floor(max).toString().length

                                    if (max_floor_length < 5) {
                                        const x = Math.round( value / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' KB'
                                    }
                                    else if (max_floor_length < 7) {
                                        const x = Math.round( value / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' MB'
                                    }
                                    else {
                                        const x = Math.round( value / 1024 / 1024 / 1024 * 100 + Number.EPSILON ) / 100
                                        return x + ' GB'
                                    }
                                }
                            }
                        }]
                    }
                }
            }
        },
        created(){
            if(!this.time )this.time = 'live'
            this.getG()
        },
    }

</script>

<style scoped>

</style>

<!--function(value, index, values) {-->
<!--console.log('CHART API',Chart.instances)-->

<!--//COUNT DIGIGTS FROM MAX-->
<!--const max_floor_length = Math.floor(max).toString().length-->
<!--console.log('LENGTH', max_floor_length)-->
<!--return value-->
<!--}-->



// WEBPACK FOOTER //
// src/components/vserver_charts/luma-vserver-main-chart.vue